// スライド画像
const swiperThumbnail = new Swiper(".swiperThumbnail", {
  slidesPerView: 3,
  spaceBetween: 0,
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    767: {
      slidesPerView: 6,
      spaceBetween: 2
    }
  },
  freeMode: true,
  watchSlidesProgress: true
});

// メインスライド
const swiperMain = new Swiper(".swiperMain", {
  effect: "fade",
  fadeEffect: { crossFade: true },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  speed: 1200,
  loop: true,
  thumbs: { swiper: swiperThumbnail }
});

swiperMain.autoplay.stop(); //画面に現れるまでswiperを停止
jQuery(window).on("scroll", function() {
  let position = jQuery(".swiperMain").offset().top - jQuery(window).innerHeight() + 100,
    scrollTop = jQuery(window).scrollTop();
  if (scrollTop > position) {
    swiperMain.autoplay.start(); //画面に現れたらswiperを開始
  } else {
    swiperMain.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
  }
});
